import { Controller } from '@hotwired/stimulus'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'

export default class extends Controller {
  static targets = [
    'table', 'loadingIcon'
  ]

  static values = {
    indexUrl: String
  }

  connect () {
    super.connect()
  }

  async refreshTableResults () {
    this.tableTarget.style.opacity = 0.1
    $(this.loadingIconTarget).show()
    const response = await fetchWithHandlingLoginRedirect(this.indexUrlValue + '?partial=table')
    this.tableTarget.innerHTML = await response.text()

    this.tableTarget.style.opacity = 1
    $(this.loadingIconTarget).hide()
  }

  click (event) {
    window.open(event.target.href, event.target.target)
  }
}
